//

import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
//
import { dispatch } from '../store';
// indexDB
import { updateIndexDBRecord } from '../../indexDB/indexdbUtilsFunctions';
import { INDEX_DB_CONFIG } from '../../indexDB/configDB';
// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  customerLocation: [],
  error: null,
};

const slice = createSlice({
  name: 'address',
  initialState,
  reducers: {
    // START LOADING
    startLoading(address) {
      address.isLoading = true;
      address.customerLocation = [];
    },

    // HAS ERROR
    hasError(address, action) {
      address.isLoading = false;
      address.error = action.payload;
      address.customerLocation = [];
    },

    // GET
    getCustomerAddressSuccess(address, action) {
      address.isLoading = false;
      address.customerLocation = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getPWACustomerAddress() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/v1/customer/crop-locations`);
      if (response?.data?.status === 1) {
        if (Array.isArray(response?.data?.data)) {
          await updateIndexDBRecord(
            INDEX_DB_CONFIG.cropLocations.storeObject,
            response?.data?.data
          );

          dispatch(slice.actions.getCustomerAddressSuccess(response.data.data));
        } else {
          console.error('invalid API response of v1/customer/crop-locations');
        }
      } else {
        dispatch(slice.actions.hasError(response.data));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
